import styled from 'styled-components'
import { GroupBase, StylesConfig } from 'react-select'

import { Typography } from 'primsell-shared-layer/components'
import { IDropdownOption } from 'primsell-shared-layer/types'
import { commonDropdownStyles } from 'primsell-shared-layer/components/atoms/dropdown/dropdown.styles'

export const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  margin-top: 20px;
`

export const List = styled.ul`
  display: flex;
  position: absolute;
  transform: translateX(-50%);
  left: 50%;

  ${Typography} {
    color: #3c3c43;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    flex-shrink: 0;
  }
`

export const PerPage = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 6px;

  ${Typography} {
    color: #3c3c43;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    flex-shrink: 0;
  }
`

interface IItemProps {
  selectedItem?: boolean
  disabled?: boolean
}

export const Item = styled.li<IItemProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  border: 1px solid #dbe0eb;
  background: ${({ selectedItem }) => (selectedItem ? '#743BBC' : '#FFF')};
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  margin: 0 5px;
  cursor: pointer;
  color: ${({ selectedItem }) => (selectedItem ? '#FFF' : '#3C3C43')};

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ selectedItem, disabled }) => (!disabled && !selectedItem ? '#f2f2f2' : '')};
  }

  ${Typography} {
    color: ${({ selectedItem }) => (selectedItem ? '#FFF' : '#3C3C43')};
  }
`

export const ItemDots = styled.li`
  display: flex;
  justify-content: center;
  align-items: end;
  height: 36px;
  margin: 0 5px;
`

export const dropdownStyles: StylesConfig<IDropdownOption, false, GroupBase<IDropdownOption>> = {
  container: (base, props) => ({
    ...commonDropdownStyles().container?.(base, props),
    width: '77px',
  }),
  option: (base, props) => ({
    ...commonDropdownStyles().option?.(base, props),
  }),
}
